module.exports = __webpack_public_path__ + "img/plan6_s.462b7fec.svg";